import React, { useEffect, useState, createContext, useContext } from 'react';
interface AuthContextType {
  isLoggedIn: boolean;
  username: string;
  login: (username: string) => void;
  logout: () => void;
}
const AuthContext = createContext<AuthContextType>({
  isLoggedIn: false,
  username: '',
  login: () => {},
  logout: () => {}
});
export function useAuth() {
  return useContext(AuthContext);
}
export function AuthProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [isLoggedIn, setIsLoggedIn] = useState(() => {
    return localStorage.getItem('mu_vanguard_logged_in') === 'true';
  });
  const [username, setUsername] = useState(() => {
    return localStorage.getItem('mu_vanguard_username') || '';
  });
  const login = (user: string) => {
    setIsLoggedIn(true);
    setUsername(user);
    localStorage.setItem('mu_vanguard_logged_in', 'true');
    localStorage.setItem('mu_vanguard_username', user);
  };
  const logout = () => {
    setIsLoggedIn(false);
    setUsername('');
    localStorage.removeItem('mu_vanguard_logged_in');
    localStorage.removeItem('mu_vanguard_username');
  };
  return <AuthContext.Provider value={{
    isLoggedIn,
    username,
    login,
    logout
  }} data-id="element-478">
      {children}
    </AuthContext.Provider>;
}